<template>
    <div class="tags">
        <NuxtLink :to="{ name: 'news' }" v-if="article.show_news">
            <NTag :bordered="false" size="large">News</NTag>
        </NuxtLink>
        <!-- <NuxtLink :to="{ name: 'about-industry' }" v-if="article.show_industry">
            <NTag :bordered="false" size="large">Industry</NTag>
        </NuxtLink> -->
        <template v-for="theme in article.themes">
            <NuxtLink :to="{ name: 'advocacy-theme', params: { theme: article.themes[0].themes_id.url } }">
                <NTag :bordered="false" size="large">{{ theme.themes_id.title }}</NTag>
            </NuxtLink>
        </template>
        <template v-for="type in article.types">
            <NuxtLink :to="{ name: 'search', query: { q: type.types_id.label.toLowerCase() } }">
                <NTag :bordered="false" size="large">{{ type.types_id.label }}</NTag>
            </NuxtLink>
        </template>
        <template v-for="tag in article.tags">
            <NuxtLink :to="{ name: 'search', query: { q: tag.toLowerCase() } }">
                <NTag :bordered="false" size="large">{{ tag }}</NTag>
            </NuxtLink>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { NTag } from 'naive-ui';
const props = defineProps<{ article: any }>()
</script>

<style lang="scss" scoped>
.tags {
    display: flex;
    gap: var(--size-gutter-small);
    flex-wrap: wrap;
    max-width: var(--text-maxwidth-body);

    &:deep(.n-tag) {
        cursor: pointer;
    }
}
</style>